import React from 'react';
import { MapPin, Phone, Mail } from 'lucide-react';

export const Footer = ({ language, translations }) => {
  const t = translations[language];

  return (
    <footer className="bg-gray-900 text-gray-300">
      <div className="container mx-auto px-4 py-12">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          <div>
            <img 
              src="https://customer-assets.emergentagent.com/job_3b7d1c0d-e4e6-424e-b604-6bb2d8c76c25/artifacts/bpyuhave_logo.jpg" 
              alt="Tasarı Bilgisayar" 
              className="h-12 w-auto mb-4 brightness-0 invert"
            />
            <p className="text-sm">{t.footer.description}</p>
          </div>

          <div>
            <h3 className="text-white font-semibold mb-4">{t.contact.title}</h3>
            <div className="space-y-3">
              <div className="flex items-start gap-2">
                <MapPin className="w-5 h-5 mt-1 flex-shrink-0" />
                <p className="text-sm">{t.contact.info.address}</p>
              </div>
              <div className="flex items-center gap-2">
                <Phone className="w-5 h-5 flex-shrink-0" />
                <p className="text-sm">{t.contact.info.phone}</p>
              </div>
              <div className="flex items-center gap-2">
                <Mail className="w-5 h-5 flex-shrink-0" />
                <p className="text-sm">{t.contact.info.email}</p>
              </div>
            </div>
          </div>

          <div>
            <h3 className="text-white font-semibold mb-4">{t.services.title}</h3>
            <ul className="space-y-2 text-sm">
              {t.services.items.slice(0, 4).map((service, index) => (
                <li key={index}>{service.title}</li>
              ))}
            </ul>
          </div>
        </div>

        <div className="border-t border-gray-800 mt-8 pt-8 text-center text-sm">
          <p>© 2025 Tasarı Bilgisayar. {t.footer.rights}</p>
        </div>
      </div>
    </footer>
  );
};
